import {
  put,
  all,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { uploadSuccess, uploadError, setMainSuccess, deleteSuccess, deleteAllSuccess, downloadImagesSuccess } from './actions';
import { carImagesNew } from '../CarSelector/actions';
import { UPLOAD_REQUEST, DOWNLOAD_CAR_IMAGES_REQUEST, SET_MAIN, DELETE, DELETE_ALL } from './constants';
import { getRequestHeadersAsLogged, getPlainRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* upload(action) {
  const files = action.files;
  const requestURL = `${API_URL}car/images`;

  const formData = new FormData();
  formData.append('car', action.car);
  formData.append('offer', action.offer);

  for (let idx = 0; idx < files.length; idx++) {
    formData.append('immagini[]', files[idx]);
  }

  try {
    const parameters = {
      method: 'POST',
      headers: getPlainRequestHeadersAsLogged(),
      body: formData,
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );
    yield put(uploadSuccess());
    yield put(carImagesNew(request.data));
  } catch (e) {
    yield put(uploadError());
    console.log('error', e);
  }
}

function* downloadImages(action) {
  const requestURL = `${process.env.API_URL}car/images/${action.carId}/download/${action.imagesType || 'default'}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    yield fetch(requestURL, parameters)
      .then(response => response.blob())
      .then(blob => download(blob, `${action.carBrand} ${action.carModel}.zip`));
    yield put(downloadImagesSuccess())
  } catch (error) {
    console.log('request error', error);
  }
}

function* setMain(action) {
  const requestURL = `${process.env.API_URL}car/images/${action.imageId}/type`;

  try {
    const parameters = {
      method: 'PUT',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify({newType: 'MAIN'})
    };

    yield fetch(requestURL, parameters)
      .then(response => responseHandler(response));

    yield put(setMainSuccess())
  } catch (error) {
    console.log('request error', error);
  }
}

function* deleteImage(action) {
  const requestURL = `${process.env.API_URL}car/images/${action.imageId}`;

  try {
    const parameters = {
      method: 'DELETE',
      headers: getRequestHeadersAsLogged(),
    };

    yield fetch(requestURL, parameters)
      .then(response => responseHandler(response));

    yield put(deleteSuccess(action.imageId))
  } catch (error) {
    console.log('request error', error);
  }
}

function* deleteAllImage(action) {
  const requestURL = `${process.env.API_URL}car/${action.carId}/images`;

  try {
    const parameters = {
      method: 'DELETE',
      headers: getRequestHeadersAsLogged(),
    };

    const response = yield fetch(requestURL, parameters)
      .then(response => responseHandler(response));

    yield put(deleteAllSuccess(response.data))
  } catch (error) {
    console.log('request error', error);
  }
}

function* actionWatcher() {
  yield takeEvery(UPLOAD_REQUEST, upload);
  yield takeLatest(DOWNLOAD_CAR_IMAGES_REQUEST, downloadImages);
  yield takeLatest(SET_MAIN, setMain);
  yield takeLatest(DELETE, deleteImage);
  yield takeLatest(DELETE_ALL, deleteAllImage);
}

export default function* carImages() {
  yield all([actionWatcher()]);
}
